//==============================================
// Navigation: filters
//==============================================


export let filters = () => {

	$('.nav_filter__select').on('change', function () {
		
		$('.nav_filter__form').trigger('submit');

	});

};